<template>
  <div class="thumb-slide">
    <div class="card-carousel">
      <div class="card-img">
        <div v-if="activeImage === 0 && isVideo">
          <div v-if="tipo_video == 'youtube'">
            <iframe
              :class="
                `video-full img-fluid animated ${classe} img-atual-thumbSlide`
              "
              :src="
                `//www.youtube.com/embed/${link_videolote}?&playlist=${link_videolote}`
              "
              allowfullscreen
            ></iframe>
            <!--iframe com auto play-->
            <!--<iframe :class="`video-full img-fluid animated ${classe} img-atual-thumbSlide`" :src="`//www.youtube.com/embed/${link_videolote}?autoplay=1;loop=1&playlist=${link_videolote}`" allowfullscreen></iframe>-->
          </div>
          <div v-if="tipo_video == 'vimeo'">
            <iframe
              :class="
                `video-full img-fluid animated ${classe} img-atual-thumbSlide`
              "
              :src="`https://player.vimeo.com/video/${link_videolote}`"
              allowfullscreen
            ></iframe>
            <!--iframe com auto play-->
            <!--<iframe :class="`video-full img-fluid animated ${classe} img-atual-thumbSlide`" :src="`https://player.vimeo.com/video/${link_videolote}?autoplay=1`" allowfullscreen></iframe>-->
          </div>
        </div>
        <div v-else>
          <!--<viewer :images="images">-->
          <!--<img v-for="img of images" :src="img.big" :key="img">-->
          <!--</viewer>-->
          <img
            v-viewer="{
              toolbar: false,
              navbar: false,
              minZoomRatio: 1,
              movable: false
            }"
            @click="stop_autoplay = true"
            class="img-zoom-in"
            :class="`img-fluid animated ${classe} img-atual-thumbSlide`"
            :src="currentImage"
            alt=""
          />
        </div>
        <div class="actions">
          <span @click="prevImage" class="prev">
            <i class="fa fa-chevron-left"></i>
          </span>
          <span @click="nextImage" class="next">
            <i class="fa fa-chevron-right"></i>
          </span>
        </div>
        <div v-for="(vistoria, id) in vistorias" :key="id" class="vistoria">
          <div v-if="vistoria.imovel_id > 0">
            <span v-if="vistoria.i_bn_ocupado == 'Desocupado'">
              <div style="display: none;">{{ (exibe_desocupado = true) }}</div>
            </span>
            <span v-else>
              <div style="display: none;">{{ (exibe_desocupado = false) }}</div>
            </span>
            <span v-if="vistoria.i_bn_permitevisitacao == true">
              <div style="display: none;">
                {{ (bn_permitevisitacao = true) }}
              </div>
            </span>
            <span v-else>
              <div style="display: none;">
                {{ (bn_permitevisitacao = false) }}
              </div>
            </span>
          </div>
          <div v-else>
            <div style="display: none;">{{ (exibe_desocupado = false) }}</div>
          </div>

          <!-- Formatação de vídeo do lote -->
          <div v-if="vistoria.veiculo_id > 0">
            <span v-if="vistoria.v_nm_youtube">
              <div style="display: none;">
                {{ (link_videolote = formataLinkVideo(vistoria.v_nm_youtube)) }}
              </div>
            </span>
          </div>

          <div v-if="vistoria.equipamento_id > 0">
            <span v-if="vistoria.e_nm_youtube">
              <div style="display: none;">
                {{ (link_videolote = formataLinkVideo(vistoria.e_nm_youtube)) }}
              </div>
            </span>
          </div>

          <div v-if="vistoria.imovel_id > 0">
            <span v-if="vistoria.i_nm_youtube">
              <div style="display: none;">
                {{ (link_videolote = formataLinkVideo(vistoria.i_nm_youtube)) }}
              </div>
            </span>
          </div>
          <!--Fim da formatação de video do youtube-->
        </div>
        <div v-if="exibe_desocupado == true">
          <span class="imovel_desocupado">
            <span class="desktop"
            ><center><strong>IMÓVEL DESOCUPADO</strong></center></span
            >
            <span class="mobile"
            ><center><strong>DESOCUPADO</strong></center></span
            >
            <div v-if="bn_permitevisitacao == true">
              <span class="texto_agenda desktop"
              ><center>AGENDE SUA VISITA PELO TELEFONE</center></span
              >
              <span class="texto_agenda mobile"
              ><center>AGENDE SUA VISITA</center></span
              >
            </div>
          </span>
        </div>
      </div>
      <carousel
        :perPageCustom="[
          [450, 2],
          [568, 3],
          [1024, 5]
        ]"
        :navigationEnabled="true"
        :paginationEnabled="false"
        :autoplay="false"
      >
        <slide
          v-for="(image, index) in images"
          :key="image.id"
          :class="['thumbnail-image', activeImage == index ? 'active' : '']"
        >
          <img :src="image.thumb" @click="setImagemAtiva(index)"/>
        </slide>
      </carousel>
    </div>
  </div>
</template>
<script>
import Carousel from "@/components/customCarousel/Carousel";
import Slide from "@/components/customCarousel/Slide";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

Vue.use(Viewer);

let interval = null;

export default {
  data() {
    return {
      activeImage: 0,
      classe: "",
      moreThan: false,
      thumbs: [],
      pos: 0,
      exibe_desocupado: false,
      bn_permitevisitacao: false,
      link_videolote: "",
      img_padra_video:
        "https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/core/galeria-play.jpg",
      tipo_video: "",
      stop_autoplay: false
    };
  },
  mounted() {
    if (!this.link_videolote) {
      this.loadAutoPlay();
    }
    if (this.isVideo) {
      this.images.unshift({thumb: this.img_padra_video});
    }
    this.stop_autoplay = false;
  },
  watch: {
    vistorias: function (v) {
      if (this.isVideo) {
        this.images.unshift({thumb: this.img_padra_video});
      }
      this.link_videolote = "";
    }
  },
  components: {
    Carousel,
    Slide
  },
  props: ["images", "vistorias"],
  computed: {
    currentImage() {
      let ativo = this.images[this.activeImage] ? this.activeImage : 0;
      return this.images[ativo].big;
    },

    isVideo() {
      return this.vistorias.some(
        vi => vi.v_nm_youtube || vi.e_nm_youtube || vi.i_nm_youtube
      );
    }
  },
  methods: {
    nextImage() {
      this.stop_autoplay = true;
      var active = this.activeImage + 1;
      if (active >= this.images.length) {
        active = 0;
      }
      this.activateImage(active);
    },
    prevImage() {
      this.stop_autoplay = true;
      var active = this.activeImage - 1;
      if (active < 0) {
        active = this.images.length - 1;
      }
      this.activateImage(active);
    },
    setImagemAtiva(imageIndex) {
      this.stop_autoplay = true;
      this.activateImage(imageIndex);
    },
    activateImage(imageIndex) {
      this.activeImage = imageIndex;
      if (!this.link_videolote) {
        //fadeOut não funciona quando é criado um 'iframe'
        this.classe = "";
      }
      //

      const limpaClass = () => {
        this.classe = "";
      };

      const element = document.querySelector(".img-atual-thumbSlide");
      var self = this;

      /*element.addEventListener("load", () => {
                    if(self.classe){
                        //self.classe = 'fadeIn'
                    }

                },false);*/
      if (element) {
        element.addEventListener("webkitAnimationEnd", limpaClass, false);
        element.addEventListener("oAnimationEnd", limpaClass, false);
        element.addEventListener("msAnimationEnd", limpaClass, false);
        element.addEventListener("animationend", limpaClass, false);
      }
    },
    loadAutoPlay() {
      var self = this;
      interval = setInterval(() => {
        if (this.stop_autoplay == false) {
          //console.log('muda');
          var active = self.activeImage + 1;
          if (active >= self.images.length) {
            active = 0;
          }
          self.activateImage(active);
        }
      }, 15000);
    },
    formataLinkVideo(link) {
      if (link.search("youtube") > 0) {
        this.tipo_video = "youtube";
        return link.replace(/(.*?=)([\w-]+)&?(.*?)?$/g, "$2");
      } else if (link.search("vimeo") > 0) {
        this.tipo_video = "vimeo";
        return link.replace(/(.*?)([\d]+)$/g, "$2");
      }
    }
  }
};
</script>
<style scoped>
.thumb-slide {
  overflow: hidden;
}

.card-carousel {
  user-select: none;
}

.img-fluid {
  width: 100%;
}

.thumbnail-image {
  margin-bottom: 10px;
  cursor: pointer;
}

.thumbnail-image.active > img {
  opacity: 0.6;
  box-shadow: 2px 2px 6px 1px rgba(0, 0, 0, 0.5);
}

.card-img {
  position: relative;
  margin-bottom: 15px;
}

.card-img > img {
  display: block;
  margin: 0 auto;
}

.desktop {
  display: block;
  /* ou inline, inline-block */
}

.mobile {
  display: none;
}

.video-full {
  width: 640px;
  height: 480px;
}

@media (max-width: 480px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
    /* ou inline, inline-block */
  }

  .video-full {
    width: 75vw;
    height: 30vh;
  }
}

.img-zoom-in {
  cursor: zoom-in;
}

.imovel_desocupado {
  font-size: 20px;
  background-color: #ffbc0c;
  float: right;
  margin-right: 5px;
  margin-top: -50px;
  color: #68302b;
  width: 55%;
  height: 63px;
  padding-top: 5px;
  padding-bottom: 5px;
  transform: translateY(-70%);
}

.texto_agenda {
  font-size: 14px;
  color: black;
}

.actions {
  font-size: 1.5em;
  height: 40px;
  position: absolute;
  top: 50%;
  margin-top: -20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #67302b;
}

.actions > span,
.prevnext-thumbs span {
  cursor: pointer;
  transition: all 250ms;
  background: #fff;
  padding: 10px;
  border-radius: 3px;
}

.actions > span.prev {
  margin-left: -2px;
}

.actions > span.next {
  margin-right: -2px;
}

.actions > span:hover {
  color: #151515;
}
</style>
<style>
.VueCarousel-wrapper {
  position: relative;
  z-index: 10;
}

.VueCarousel-navigation a {
  text-decoration: none !important;
}

.VueCarousel-navigation a.VueCarousel-navigation-prev {
  left: 24px !important;
  background: #fff;
  border-radius: 2px;
  z-index: 20;
}

.VueCarousel-navigation a.VueCarousel-navigation-next {
  right: 24px !important;
  border-radius: 2px;
  background: #fff;
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/components/thumbSlide/ThumbSlide.vue